import LayoutModel from '../../models/layout-model';
import { EventBus } from '../../services/event-bus-service';

export const LayoutModule = {
  state: {
    // Layout id loaded from settings
    // if there is no layout provided from url, then this one will be used by default
    layoutID: '',
    // We will save all layouts here
    layouts: [],
    // This is the layout which will be set from url path - route
    currentLayout: '',
    /**
     * Show hide all widgets after sub router widget in middle column
     */
    toggleAfterRouterWidgets: true,
    /**
     * Should left col be expanded or collapsed
     */
    leftColExpanded: true,
  },
  mutations: {
    /**
     * Load layouts from api
     * @param state
     * @param layouts
     */
    setLayouts(state, layouts) {
      if (layouts.length) {
        for (let i = 0, len = layouts.length; i < len; i += 1) {
          if (layouts[i].n) {
            state.layouts.push(new LayoutModel(layouts[i]));
            // set default layout
            if (layouts[i].d === true) {
              state.layoutID = layouts[i].lid;
            }
          }
        }
      }
    },
    /**
     * Set current layout from route
     * @param state
     * @param route
     */
    setCurrentLayoutFromRoute(state, route) {
      state.currentLayout = route;
    },
    /**
     * Show after route widgets
     * @param state
     */
    showAfterRouteWidgets(state) {
      state.toggleAfterRouterWidgets = true;
    },
    /**
     * Hide after route widgets
     * @param state
     */
    hideAfterRouteWidgets(state) {
      state.toggleAfterRouterWidgets = false;
    },
    /**
     * Show collapse left col
     * @param state
     */
    toggleLeftCol(state) {
      state.leftColExpanded = !state.leftColExpanded;
      EventBus.$emit('leftColToggle', state.leftColExpanded);
    },
  },
  actions: {},
  getters: {
    /**
     * Get layout data
     * @param state
     * @returns {*}
     */
    getDefaultLayoutData(state) {
      /**
       * if we have route, then we will use route name for layout search
       * otherwise if we don't have route we will use start layout which
       * will be loaded by layout id from settings
       */
      let data = {
        widgets: [],
        settings: [],
      };
      let layoutField = state.currentLayout !== '' ? 'name' : 'layoutId';
      let compareValue = state.currentLayout !== '' ? state.currentLayout : state.layoutID;
      for (let i = 0, len = state.layouts.length; i < len; i += 1) {
        if (state.layouts[i][layoutField] === compareValue) {
          data.widgets = state.layouts[i].widgets;
          data.settings = state.layouts[i].settings;
        }
      }
      return data;
    },
    /**
     * Get default layout from layout settings
     * @param state
     */
    getDefaultLayout(state) {
      return state.layouts.find(layout => layout.default);
    },
    /**
     * Get specific col in defauly layout by col id if it exists, false otherwise
     * @param {*} _state 
     * @param {*} getters 
     */
    getDefaultLayoutCol(_state, getters) {
      const dLayout = getters.getDefaultLayout;
      return (colIdx) => {
        if (dLayout && dLayout.widgets && dLayout.widgets[0] && dLayout.widgets[0].cols) {
          return dLayout.widgets[0].cols[colIdx];
        }
        return false;
      };
    },
    /**
     * Get list of all widgets in default layout
     * @param {*} _state 
     * @param {*} getters 
     */
    getAllDefaultLayoutWidgets(_state, getters) {
      const dLayout = getters.getDefaultLayout;
      if (dLayout && dLayout.widgets && dLayout.widgets[0] && dLayout.widgets[0].cols) {
        return dLayout.widgets[0].cols.flatMap(col => col.widgets);
      }
      return [];
    },
    /**
     * Get specific widget in default layout by component name if it exists, undefined otherwise
     * @param {*} _state 
     * @param {*} getters 
     */
    getDefaultLayoutWidget(_state, getters) {
      return (widgetName) => {
        return getters.getAllDefaultLayoutWidgets.find(widget => widget.comp === widgetName);
      };
    },
    /**
     * Get layout by name
     * @param state
     * @returns {Function}
     */
    getLayoutByName(state) {
      return (name) => {
        for (let i = 0, len = state.layouts.length; i < len; i += 1) {
          if (state.layouts[i].name === name) {
            return state.layouts[i];
          }
        }
      };
    },
    /**
     * Get specific col in specific layout by layout name and col id if it exists, false otherwise
     * @param {*} _state 
     * @param {*} getters 
     */
    getLayoutByNameCol(_state, getters) {
      return (layoutName, colIdx) => {
        const layout = getters.getLayoutByName(layoutName);
        if (layout && layout.widgets && layout.widgets[0] && layout.widgets[0].cols) {
          return layout.widgets[0].cols[colIdx];
        }
        return false;
      };
    }
  },
};
